import React, { useEffect, useState } from 'react';
import CartItems from '../CartItems/CartItems';
import './Cart.css';

const Cart = ({ cart,removeCart }) => {

    const [newCart, setNewCart] = useState([])

    useEffect(()=>{
        setNewCart(cart)
    },[cart])

    const removeFromCart = (id) => {
        const find = newCart.find(item => item.id === id);
        const index = newCart.indexOf(find);
        if(index > -1) {
            cart.splice(index,1);
        }
        setNewCart([...cart])
    }

    const chooseOne = () => {
        if(newCart.length > 0 ) {
            const random = Math.floor(Math.random() * newCart.length);
        alert(`You Can Choose ${newCart[random].name}`);
        }
    }



    return (
        <div className='cart'>
            <h1>Cart</h1>

            <div>
                <ul>
                    {
                        newCart.map(cake => <CartItems
                        cake={cake}
                        removeFromCart={removeFromCart}
                        key={cake.id}
                        ></CartItems>)
                    }
                </ul>
            </div>

            <div className='cart-btn'>
                <button
                className='btn choose-one' 
                onClick={() => chooseOne()}
                >Choose 1 For Me</button>
                <button 
                className='btn choose-again'
                onClick={() => removeCart()}
                >Reset</button>
            </div>
        </div>
    );
};

export default Cart;